import { render, staticRenderFns } from "./UpdateCourseModal.vue?vue&type=template&id=6620a6aa"
import script from "./UpdateCourseModal.vue?vue&type=script&lang=js"
export * from "./UpdateCourseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports